import {Box, Heading, HeadingAlign} from 'platform/foundation';

interface MazdaDetailTableHeaderCellProps {
  label: string;
  align?: HeadingAlign;
  isLast?: boolean;
}

export function MazdaDetailTableHeaderCell(props: MazdaDetailTableHeaderCellProps) {
  return (
    <Box paddingVertical={2}>
      <Box
        paddingHorizontal={4}
        borderRight={props.isLast ? undefined : '1px solid'}
        borderColor="general.separator"
      >
        <Heading size={5} color="secondary" align={props.align}>
          {props.label}
        </Heading>
      </Box>
    </Box>
  );
}
